module.exports = __webpack_public_path__ + "img/var_02_xrobot1.9caa8737.png";